<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'WidgetInfobarSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    content: '',
    textColor: '',
    backgroundColor: '',
    datePublication: null,
    dateExpiration: null
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

watch(() => form.value.settings, () =>
{
    triggerModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Data publikacji]]]')">
        <IdeoDatetime v-model="form.settings.datePublication" name="datePublication" type="datetime" />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Data wygaśnięcia]]]')">
        <IdeoDatetime v-model="form.settings.dateExpiration" name="dateExpiration" type="datetime" />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Barwa tekstu]]]')" :invalid-feedback="form.$errors.first('settings.textColor')" :state="form.$errors.state('settings.textColor')">
        <IdeoFormInput v-model="form.settings.textColor" type="color" name="settings.textColor" />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Barwa tła]]]')" :invalid-feedback="form.$errors.first('settings.backgroundColor')" :state="form.$errors.state('settings.backgroundColor')">
        <IdeoFormInput v-model="form.settings.backgroundColor" type="color" name="settings.backgroundColor" />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Opis]]]')" :invalid-feedback="form.$errors.first('settings.content')" :state="form.$errors.state('settings.content')">
        <RichTextEditor id="editorContent" v-model="form.settings.content" />
    </IdeoFormGroup>
</template>
